import React, { useState, useEffect } from "react";
import "./PaymentModal.css";
import { useNavigate } from "react-router-dom";

export default function PaymentModal({
  onClose,
  subscriptionStatus,
  subscriptionEndDate,
  user_id,
}) {
  const subscriptionTypeMapper = {
    active: "Премиум",
    expired: "Бесплатно",
    cancelled: "Отменена",
    trial: "Пробный период",
  };

  const [subscriptionType, setSubscriptionType] = useState(subscriptionStatus);
  const [subscriptionCancelled, setSubscriptionCancelled] = useState(false);
  const subscriptionCancelledText = "Подписка отменена";

  const navigate = useNavigate();

  const handleSubscribe = () => {
    navigate("/payment", { state: { subscriptionType } });
    onClose();
  };

  useEffect(() => {
    const fetchSubscriptionStatus = async () => {
      const response = await fetch(`/api/subscription/?user_id=${user_id}`);
      const data = await response.json();
      setSubscriptionType(data.status);
    };
    fetchSubscriptionStatus();
  }, [user_id]);

  const handleCancelSubscription = async () => {
    const response = await fetch(`/api/subscription/?user_id=${user_id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to cancel subscription");
    }

    setSubscriptionCancelled(true);
    setTimeout(() => {
      onClose();
    }, 2000);
  };

  return (
    <div className="payment-modal-backdrop">
      <div className="payment-modal-content">
        <button className="payment-modal-close" onClick={onClose}>
          &times;
        </button>

        {subscriptionCancelled ? (
          <>
            <h2>{subscriptionCancelledText}</h2>
          </>
        ) : (
          <>
            <h2>Текущий уровень подписки</h2>

            {subscriptionType !== "expired" ? (
              <p>
                <span className="purple">
                  {subscriptionTypeMapper[subscriptionType]}
                </span>
                <p>
                  Активна до{" "}
                  <span className="greens">{subscriptionEndDate}</span>
                </p>
              </p>
            ) : (
              <p>
                <span className="purple">Бесплатно</span>
              </p>
            )}

            {subscriptionType === "active" ? (
              <button
                className="cancel-subscription-btn"
                onClick={handleCancelSubscription}
              >
                Отменить подписку
              </button>
            ) : (
              <button
                className="cancel-subscription-btn"
                onClick={handleSubscribe}
              >
                Подписаться
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
}
